/* eslint-disable max-len */
import { commonStyleSheet } from 'library/common-styles';
import { ThemeType } from '../../theme/jss-types';

export const purchaseOrderStyles = (theme: ThemeType) => ({
    main: {
        width: '100%',
        padding: '5px 6px 6px 3px',
        height: '100%',
    },
    filters: {
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
    },
    filter: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginRight: 12,
    },
    dateRange: {
        '& .ant-picker-cell-in-view::after': {
            display: 'none !important',
            content: 'none !important',
        },
        '& .ant-picker-cell:hover .ant-picker-cell-in-view:hover::after': {
            display: 'none !important',
            content: 'none !important',
        },
        '& .ant-picker-panel-container': {
            backgroundColor: '#f7f7f7 !important',
            borderRadius: '4px !important',
            display: 'flex !important',
            flexDirection: 'row-reverse !important',
        },
        '& .ant-picker-cell-in-view .ant-picker-cell-inner': {
            display: 'flex !important',
            alignItems: 'center !important',
            justifyContent: 'center !important',
            width: '32px !important',
            height: '32px !important',
            padding: '0 !important',
            backgroundColor: 'white !important',
            borderRadius: '4px !important',
            margin: '1px !important',
            boxSizing: 'border-box !important',
            '&:hover': {
                backgroundColor: '#b9e0ff !important',
            },
        },
        '& .ant-picker-cell-in-view': {
            padding: '0 !important',
            '&:hover': {
                backgroundColor: 'transparent !important',
            },
        },
        '& .ant-picker-cell-in-view.ant-picker-cell-in-range .ant-picker-cell-inner, & .ant-picker-cell-in-view.ant-picker-cell-range-start .ant-picker-cell-inner, & .ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner': {
            backgroundColor: `${theme.tertiaryFillColor} !important`,
        },
        '& .ant-picker-cell-in-view.ant-picker-cell-range-start .ant-picker-cell-inner, & .ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner': {
            backgroundColor: `${theme.secondaryFillColor} !important`,
            borderColor: `${theme.secondaryFillColor} !important`,
            fontWeight: 'bold !important',
        },
        '& .ant-picker-cell-in-view.ant-picker-cell-in-range::before': {
            background: '#f7f7f7',
        },
        '& .ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single)::before': {
            background: '#f7f7f7',
        },
        '& .ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-end-single)::before': {
            background: '#f7f7f7',
        },
        '& .ant-picker-cell-disabled::before': {
            background: '#f7f7f7',
        },
        '& .ant-picker-date-panel .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-start .ant-picker-cell-inner::after': {
            background: 'transparent !important',
        },
        '& .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover::before': {
            background: 'transparent !important',
        },
        '& .ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single).ant-picker-cell-range-hover-start::before': {
            background: 'transparent !important',
        },
        '& .ant-picker-date-panel .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-end .ant-picker-cell-inner::after': {
            background: 'transparent !important',
        },
        '& .ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-end-single).ant-picker-cell-range-hover-end::before': {
            background: 'transparent !important',
        },
        '& .ant-picker-footer': {
            minWidth: 140,
            padding: 4,
        },
        '& .ant-picker-ranges .ant-picker-preset > .ant-tag-blue': {
            color: 'black',
            background: 'transparent !important',
            borderColor: 'transparent !important',
            fontWeight: 600,
            fontSize: '12px',
            padding: '8px',
        },
        '& .ant-picker-ranges > li:hover': {
            display: 'inline-block',
            backgroundColor: `${theme.tertiaryFillColor} !important`,
            borderRadius: '4px',
        },
        '& .ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner': {
        },
    },
    selectFilter: {
        margin: '0 5px !important',
        width: '200px !important',
        '& .ant-select:not(.ant-select-customize-input) .ant-select-selector': {
            backgroundColor: '#fafafa',
        },
        '& .ant-select-selector': {
            width: 'auto !important',
            borderRadius: '6px !important',
            alignItems: 'center',
        },
        '& .ant-select-dropdown': {
            padding: '12px !important',
            borderRadius: '6px !important',
            gap: '16px !important',
        },
        '& .ant-select-item': {
            padding: '8px !important',
            borderRadius: '4px !important',
            gap: '10px !important',
            fontWeight: 600,
        },
        '& .ant-select-item-option-selected': {
            backgroundColor: `${theme.tertiaryFillColor} !important`,
            padding: '8px !important',
            borderRadius: '4px !important',
            gap: '10px !important',
        },
    },
    dateFilter: {
        width: 220,
        backgroundColor: '#FFFFFF',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'end',
        '& .ant-picker': {
            borderRadius: '6px',
            height: 32,
        },
        '& .ant-picker-input > input': {
            fontSize: '13px',
        },
    },
    footer: {
        height: 32,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#F7F7F7',
    },
    filterText: {
        color: '#333333',
        fontFamily: 'Open Sans',
        fontSize: 12,
        letterSpacing: 0,
        marginRight: 8,
    },
    cellValue: {
        color: '#111111',
        fontFamily: 'Open Sans',
        fontSize: 12,
        fontWeight: 600,
        letterSpacing: 0,
        wordWrap: 'break-word',
        whiteSpace: 'break-spaces',
    },
    cellNa: {
        color: '#999999',
        fontFamily: 'Open Sans',
        fontSize: 12,
        fontWeight: 600,
        letterSpacing: 0,
    },
    extraFilters: {
        width: '100%',
        borderRadius: '0 2px 0 0',
        backgroundColor: '#FFFFFF',
        padding: '8px 16px',
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: 4,
        flexDirection: 'row',
    },
    leftFilters: {
        display: 'flex',
        alignItems: 'center',
    },
    rightFilters: {
        display: 'flex',
        alignItems: 'center',
        height: 32,
        '& .ant-btn': {
            boxSizing: 'border-box',
            height: 32,
            borderRadius: 3,
            fontFamily: 'Open Sans',
            fontSize: 12,
            fontWeight: 600,
            laterSpacing: 0,
        },
        '& .ant-btn-ghost': {
            border: `1px solid ${theme.primaryColor}`,
        },
        '& .ant-btn-primary, .ant-btn-primary:hover, .ant-btn-primary:focus': {
            backgroundColor: theme.primaryColor,
        },
    },
    searchInput: {
        width: '100%',
        borderRadius: '6px !important',
    },
});

export const purchaseDetailsStyles = (theme: ThemeType) => ({
    ...commonStyleSheet(theme),
    main: {
        fontFamily: 'Open Sans',
        letterSpacing: 0,
        '& .ant-drawer-header': {
            padding: 16,
            position: 'fixed',
            width: '100%',
            zIndex: 10,
        },
        '& .ant-drawer-body': {
            backgroundColor: '#FFF',
            alignSelf: 'center',
            width: '100%',
        },
        '& .ant-btn-primary': {
            borderRadius: 4,
            marginRight: 8,
            color: '#FFFFFF',
            fontFamily: 'Open Sans',
            fontWeight: 600,
            letterSpacing: 0,
            height: 32,
            fontSize: 12,
        },
        '& .ant-btn-link': {
            fontFamily: 'Open Sans',
            fontWeight: 600,
            letterSpacing: 0,
            fontSize: 12,
            color: `${theme.primaryColor} !important`,
        },
        '& .ant-input': {
            boxSizing: 'border-box',
            height: 32,
            border: '1px solid #999999',
            borderRadius: 4,
            backgroundColor: '#FFFFFF',
        },
    },
    header: {
        ...commonStyleSheet(theme).flexRow,
        width: '100%',
        justifyContent: 'space-between',
        padding: 0,
    },
    addText: {
        ...commonStyleSheet(theme).flexRow,
        color: '#000000',
        fontWeight: 600,
        letterSpacing: 0,
        fontFamily: 'Open Sans',
        fontSize: 20,
    },
    closeIcon: {
        marginRight: 8,
        fontSize: 16,
        cursor: 'pointer',
        color: '#000000',
        letterSpacing: 0,
        fontFamily: 'Open Sans',
        fontWeight: 600,
    },
    body: {
        padding: 16,
        paddingBottom: 8,
    },
    name: {
        color: '#666666',
        fontSize: 10,
        letterSpacing: 0,
        width: '25%',
    },
    value: {
        color: '#111111',
        fontSize: 12,
        fontFamily: 'Open Sans',
        fontWeight: 600,
        letterSpacing: 0,
    },
    box: {
        borderRadius: 4,
        backgroundColor: '#FAFAFA',
        width: '100%',
        marginBottom: 8,
    },
    fieldGroup: {
        display: 'flex',
        flexWrap: 'wrap',
        overflowWrap: 'break-word',
        alignItems: 'start',
        fontSize: 12,
        width: '30%',
        margin: '0 10px',
    },
    fieldTitle: {
        display: 'inline-block',
        width: '50%',
        fontSize: 10,
    },
    fieldValue: {
        display: 'inline-block',
        width: '50%',
        fontWeight: 600,
        fontSize: 12,
    },
    tabDetails: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'start',
    },
    hr: {
        width: '98%',
        height: 1,
        backgroundColor: '#CCCCCC',
        marginTop: 4,
    },
    pair: {
        ...commonStyleSheet(theme).flexRow,
        marginBottom: 16,
        width: '50%',
    },
    view: {
        cursor: 'pointer',
        color: theme.primaryColor,
        fontSize: '12px',
        fontWeight: 600,
        padding: '10px',
    },
});
